/**
 * Hero strip — autoplaying muted background video + headline + NearMeSearch.
 */
import LiveReviewBadge from "../../components/LiveReviewBadge";
import NearMeSearch from "../../components/NearMeSearch";

export default function HomeHero() {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-[72vh] w-full overflow-hidden flex items-end bg-zen-elevated"
        >
            {/* Autoplay/muted/looping background video — replaces the static
                dispensary photo. playsInline keeps it inline on iOS,
                disablePictureInPicture avoids the floating PiP button. */}
            <video
                data-testid="hero-video"
                autoPlay
                muted
                loop
                playsInline
                disablePictureInPicture
                preload="auto"
                poster="https://customer-assets.emergentagent.com/job_zenzest-near-me/artifacts/xkyk453i_ZenZest%20Pic.jpeg"
                className="absolute inset-0 w-full h-full object-cover opacity-65"
                aria-hidden="true"
            >
                <source
                    src="https://customer-assets.emergentagent.com/job_zenzest-near-me/artifacts/4e4p8xkv_ZENZEST_COMM_2_1.mp4"
                    type="video/mp4"
                />
            </video>
            <div className="absolute inset-0 bg-gradient-to-b from-zen-elevated/40 via-zen-elevated/55 to-zen-elevated/95" />
            <div className="absolute inset-0 zen-radial-olive opacity-60" />

            <div className="relative w-full max-w-[1400px] mx-auto px-6 sm:px-10 pb-12 sm:pb-16 pt-24 sm:pt-28">
                <div className="max-w-3xl zen-fade-up">
                    <div className="text-[11px] uppercase tracking-[0.35em] text-zen-olive-light mb-6 flex items-center gap-3">
                        <span className="w-8 h-px bg-zen-olive-light" />
                        NY OCM-Licensed ·{" "}
                        <LiveReviewBadge
                            tone="light"
                            showLink
                            testid="hero-live-reviews"
                        />
                    </div>
                    <h1 className="font-serif text-5xl sm:text-7xl lg:text-[110px] font-light text-white leading-[0.95] tracking-tight mb-8">
                        A weed dispensary
                        <br />
                        near you,{" "}
                        <span className="italic text-zen-olive-light">
                            done well.
                        </span>
                    </h1>
                    <p className="text-white/85 text-base sm:text-lg max-w-xl leading-relaxed mb-6">
                        Two ZenZest flagships — Queens / Nassau Long Island and
                        Staten Island — serving 80+ neighborhoods with curated
                        cannabis, free same-day delivery, and budtenders who
                        actually know the plant.
                    </p>
                    <NearMeSearch tone="dark" />
                </div>
            </div>
        </section>
    );
}
